<template>
    <div>
		<Dialog :visible.sync="exibirDialogSincronizar" header="Sincronizar Funcionários e Imagens" :modal="true" class="p-fluid" :style="{width: '60vw'}" @hide="fecharModal">					
			<TabView @tab-change="tab">
				<TabPanel header="Sincronização" class="p-mt-3">
					<SincronizacaoGeral ref="sincronizacaoGeral"/>
				</TabPanel>
				<TabPanel :header="headerSincPendente" class="p-mt-3">
					<SincronizacaoPushAsync ref="sincronizacaoPushAsync"/>
				</TabPanel>
			</TabView>		
			<template #footer>
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
				<Button label="Enviar" icon="pi pi-check" @click="enviar"/>				
			</template>
		</Dialog>
    </div>
</template>

<script>
import SincronizacaoGeral from '@/components/pages/cadastro/dispositivosColetas/sinc/SincronizacaoGeral.vue';
import SincronizacaoPushAsync from '@/components/pages/cadastro/dispositivosColetas/sinc/SincronizacaoPushAsync.vue';

export default {
	props: {        
        iniciarSincronizacaoPushAsync: {
            type: Function,
            required: true,
        }
    },
	data() {
        return {
			headerSincPendente: 'Sincronização Pendente',
			exibirDialogSincronizar: false,			
			tabAtiva: 'Sincronização'
        }        
    },
	methods: {
		tab(event) {
			this.tabAtiva = event.tab.header;					
		},
		/**
		 * 
		 */
		exibir(dados) {		
			this.headerSincPendente = 'Sincronização Pendente';
			this.exibirDialogSincronizar = true;
			setTimeout(() => {
				this.$refs.sincronizacaoGeral.setCnpjSelecionado({...dados.cnpj});
				this.$refs.sincronizacaoPushAsync.setCnpjSelecionado({...dados.cnpj}, (qtdIntesSincronizar) => {
					this.headerSincPendente = qtdIntesSincronizar ? `Sincronização Pendente (${qtdIntesSincronizar})` : 'Sincronização Pendente';
				});
			}, 500);
		},
		/**
		 * 
		 */
		enviar() {
			if(this.tabAtiva == 'Sincronização') {
				this.$refs.sincronizacaoGeral.criarTarefa((resposta) => {					
					this.finalizar(resposta);
				});
			} else {
				this.$refs.sincronizacaoPushAsync.iniciarSincronizacaoDeTarefasPendentes((resposta) => {
					this.finalizar(resposta);
				});
			}
		},
		/**
		 * 
		 */
		finalizar(resposta) {		
			if(resposta.erro) {
				return;
			}			
			if(resposta.temPushAsync) {// Tela de monitoramento		
				const requisicao = { sincronizacaoGeral: false, relogiosTarefaPendentes: [] };		
				if(this.tabAtiva == 'Sincronização') {
					requisicao.sincronizacaoGeral = true;					
				} else {
					requisicao.relogiosTarefaPendentes = resposta.relogiosPushAsync;
				}
				this.iniciarSincronizacaoPushAsync(requisicao);
			}
			this.fecharModal();
		},
        /**
         * 
         */
        fecharModal() {
            this.exibirDialogSincronizar = false;
        }	
	},
    components: {
		'SincronizacaoGeral': SincronizacaoGeral,
		'SincronizacaoPushAsync': SincronizacaoPushAsync,
    }
}
</script>
